<script>
import { toRaw, toValue } from 'vue'
import JsBarcode from 'jsbarcode';
import { ref } from 'vue'
import { onMounted } from 'vue';
const barcodeElement = ref(null); // Template ref for the SVG element
export default {
  props: {
    barcodeValue: String,
    itemName: String,
    sizeCol: String,
    // svg: String,
    sku: String,
    price: String,
    index: Number,
    updateAll: Boolean
  },
  data() {
    return {
    }
  },
  methods: {
    //edit later
    
    
  },
  created(){
    console.log(this.index)
  },
  updated() {
      JsBarcode(`#cv${this.index}`, this.barcodeValue, {
      format: "CODE128",
      // lineColor: "",
      width:1.5,
      height:30,
      fontSize:12,
      displayValue: true
      });
      
      console.log(this.updateAll)
  }
  
}
//Test barcode
//30058633
//97609353
//66677897

</script>

<template>

<div class="barcode-container">
    
    {{ sizeCol }} <br>
    {{ sku }}
    <img :id="`cv${this.index}`"></img>
     <!-- <svg id="barcode"></svg> -->
    {{ itemName }} <br>
    {{ price }}
    <!-- <button @click="updated">Create</button> -->
</div>
</template>

<style lang="scss" scoped>
    .barcode-container{
        margin: auto;
        height:200px;
        width: 200px;
        max-width: 200px;
        max-height: 200px;
        // margin-bottom: 2em;
        background-color: white;
        color: black;
        display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    font-size: .75em;
//   padding: 2em;
  font-weight: bold;
    }
</style>
